import { createSlice } from '@reduxjs/toolkit';
import { GAME_ROOMS } from '../../../screens/Home/constants';
var sliceName = 'GAME_ROOMS';
var initialState = {
  data: [],
  activeGameRoom: null
};
var gameRoomsSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
    setGameRooms: function setGameRooms(state, action) {
      state.data = action.payload;
    },
    setActiveGameRoom: function setActiveGameRoom(state, action) {
      state.activeGameRoom = action.payload;
    },
    setFavouritesGames: function setFavouritesGames(state, action) {
      var favouritesRoom = state.data.find(function (room) {
        return room.urlPath === GAME_ROOMS.FAVOURITES;
      });
      if (favouritesRoom) {
        var uniqueGames = Array.from(new Set(action.payload.map(function (game) {
          return game.GAME_ID;
        }))).map(function (id) {
          return action.payload.find(function (game) {
            return game.GAME_ID === id;
          });
        });
        favouritesRoom.games = uniqueGames;
      }
    }
  }
});
var actions = gameRoomsSlice.actions,
  reducer = gameRoomsSlice.reducer;
var setGameRooms = actions.setGameRooms,
  setActiveGameRoom = actions.setActiveGameRoom,
  setFavouritesGames = actions.setFavouritesGames;
export { setGameRooms, setActiveGameRoom, setFavouritesGames };
export default reducer;